exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expense-categories > .heading[data-v-49e58c1e] {\n  margin-bottom: 10px;\n  justify-content: flex-start;\n  align-items: center;\n}\n.expense-categories .expense-category[data-v-49e58c1e] {\n  margin: 0 10px 0 0;\n}\n.expense-categories .expense-item[data-v-49e58c1e]:not(:last-of-type) {\n  padding-bottom: 10px;\n}\n", ""]);

// exports
